// extracted by mini-css-extract-plugin
module.exports = {"exitEventImage":"ExitEvent_exitEventImage__x6zMG","closeDiv":"ExitEvent_closeDiv__2vX1F"};